import styled from 'styled-components';

const SectionContainer = styled.div`
  max-width: 1620px;
  margin: 0 auto;
`;

export default SectionContainer;
